import {Consts} from "../pages/consts";
import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import useMmcService from "../../services/MmcService";
import InitContext from "../pages/InitContext";
import Diseases from "../patientInit/Diseases";
import useDialogDrag from "../../hooks/useDialogDrag";
import {getPatientName} from "../pages/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const PatientDisease = ({patient, updatePatient, showDialog, onCloseDialog}) => {
  const { t } = useTranslation();
  const [patientDiseases, setPatientDiseases] = useState([]);
  const [patientsDiseasesInDb, setPatientsDiseasesInDb] = useState([]);
  const context = useContext(InitContext);
  const {clearError, getDbDiseases, saveDbDisease} = useMmcService();
  const { dragStyle, isDragging, onDragHandleMouseDown } = useDialogDrag(showDialog);
  const disabledSeeNames = context?.role === Consts.STUDY_DIRECTOR || context?.role === "admin";

  const dialogTitle = `${t("diseases", { defaultValue: "Diseases" })}: ${getPatientName(patient, 
    disabledSeeNames)}`;

  useEffect(() => {
    clearError();

    if (patient?.id && context?.token && context?.token !== "") {
      getDbDiseases(context?.token, patient?.id).then((data) =>
        setPatientsDiseasesInDb(data?.diseases),
      );
    }
  }, []);

  const saveDiseases = () => {
    clearError();

    patientDiseases?.forEach((disease) => {
      if (context?.token && context?.token !== "") {
        saveDbDisease(context?.token, disease, patient?.id).then((id) => {
          disease = { ...disease, id };
          setPatientsDiseasesInDb([...patientsDiseasesInDb, disease]);
          setPatientDiseases([]);
          updatePatient(disease?.begin);
        });
      }
    });

    onCloseDialog();
  };

  let diseasesToShow = []

  if (patientsDiseasesInDb?.length > 0) {
    diseasesToShow = [...patientsDiseasesInDb];
  }

  if (patientDiseases?.length > 0) {
    diseasesToShow = [...diseasesToShow, ...patientDiseases];
  }

  return(
    <div className="w3-modal" style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}>
      <div
        className={`w3-modal-content w3-card-4 w3-animate-zoom w3-theme-l3 disease-tree dialog-draggable ${context?.role === Consts.HCP_PRESCRIBER
          ? "dialog-wide"
          : "dialog-small"} ${isDragging ? "dialog-draggable--dragging" : ""}`}
        style={dragStyle}
      >
        <header className="dialog-drag-header" onMouseDown={onDragHandleMouseDown}>
          <strong className="dialog-drag-header__title">{dialogTitle}</strong>
          <button
            type="button"
            className="dialog-drag-close"
            onClick={onCloseDialog}
            aria-label={t("close", { defaultValue: "Close" })}
            title={t("close", { defaultValue: "Close" })}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </header>
        <Diseases patientDiseases={patientDiseases} onSetPatientDiseases={setPatientDiseases}
                  diseasesToShow={diseasesToShow} setPatientsDiseasesInDb={setPatientsDiseasesInDb}/>
        <div className="w3-container w3-right-align w3-padding-small">
          {context?.role === Consts.HCP_PRESCRIBER &&
            <button
              onClick={saveDiseases}
              className={`w3-btn w3-round-xlarge  ${patientDiseases?.length > 0 ? "w3-red" : "w3-grey w3-disabled"}`}
                      type="text"
            >
              {t("save_diseases")}
            </button>
          }
        </div>
      </div>
    </div>
  );
}

export default PatientDisease;